import React, { Component } from 'react';
import './index.css';

import faceImg from './me.jpg';

import NavBar from '../NavBar/';
import Hexagon from './components/Hexagon/';
import HexText from './components/HexText/';

import $ from 'jquery'

export default class About extends Component {
  render() {

    $(document).ready(function(){
      $('.skillbar').each(function(){
        $(this).find('.skillbar-bar').animate({
          width:$(this).attr('data-percent')
        },4500);
      });
    });

    return (
      <div id="about-me">
        <NavBar title="About Me" />
        <div className="hex-container">
          <Hexagon icon="mdi mdi-speedometer" />
          <Hexagon icon="mdi mdi-cellphone-link" />
          <Hexagon icon="mdi mdi-lightbulb-outline" />
          <Hexagon icon="mdi mdi-rocket" />
        </div>
        <div className="texter">
          <HexText title="Fast" description="Fast load times and lag free interaction, my highest priority." />
          <HexText title="Responsive" description="My layouts will work on any device, big or small." />
          <HexText title="Intuitive" description="Strong preference for easy to use, intuitive UX/UI." />
          <HexText title="Dynamic" description="Websites don't have to be static, I love making pages come to life." />

        </div>


        <div className="left-side-flex-container">
          <div className="left-side">
            <img src={faceImg} alt="me.jpg" />
          </div>
          <div className="right-side">
            <div className="skillbar clearfix " data-percent="65%">
              <div className="skillbar-title" ><span>JavaScript</span></div>
              <div className="skillbar-bar" ></div>
              <div className="skill-bar-percent">65%</div>
            </div>

            <div className="skillbar clearfix " data-percent="60%">
              <div className="skillbar-title" ><span>React.js</span></div>
              <div className="skillbar-bar" ></div>
              <div className="skill-bar-percent">60%</div>
            </div>

            <div className="skillbar clearfix " data-percent="70%">
              <div className="skillbar-title" ><span>Node.js</span></div>
              <div className="skillbar-bar" ></div>
              <div className="skill-bar-percent">70%</div>
            </div>

            <div className="skillbar clearfix " data-percent="50%">
              <div className="skillbar-title" ><span>PHP/SQL</span></div>
              <div className="skillbar-bar" ></div>
              <div className="skill-bar-percent">40%</div>
            </div>

            <div className="skillbar clearfix " data-percent="75%">
              <div className="skillbar-title" ><span>NoSQL</span></div>
              <div className="skillbar-bar" ></div>
              <div className="skill-bar-percent">75%</div>
            </div>

            <div className="skillbar clearfix " data-percent="40%">
              <div className="skillbar-title" ><span>Python</span></div>
              <div className="skillbar-bar" ></div>
              <div className="skill-bar-percent">30%</div>
            </div>

            <div className="skillbar clearfix " data-percent="54%">
              <div className="skillbar-title" ><span>C#</span></div>
              <div className="skillbar-bar" ></div>
              <div className="skill-bar-percent">48%</div>
            </div>

            <div className="skillbar clearfix " data-percent="45%">
              <div className="skillbar-title" ><span>Photoshop</span></div>
              <div className="skillbar-bar" ></div>
              <div className="skill-bar-percent">20%</div>
            </div>
          </div>
        </div>
      </div>
    );
  }
};




// WEBPACK FOOTER //
// ./src/components/About/index.js